export const SummaryIcon = ({ ...props }) => {
  return (
    <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m3.25 6.5c.69036 0 1.25-.55964 1.25-1.25s-.55964-1.25-1.25-1.25-1.25.55964-1.25 1.25.55964 1.25 1.25 1.25zm3.75-1.25c0-.41421.33579-.75.75-.75h9.5c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-9.5c-.41421 0-.75-.33579-.75-.75zm.75 3.75c-.41421 0-.75.33579-.75.75 0 .4142.33579.75.75.75h9.5c.4142 0 .75-.3358.75-.75 0-.41421-.3358-.75-.75-.75zm0 4.5c-.41421 0-.75.3358-.75.75s.33579.75.75.75h9.5c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75zm-3.25-3.75c0 .6904-.55964 1.25-1.25 1.25s-1.25-.5596-1.25-1.25c0-.69036.55964-1.25 1.25-1.25s1.25.55964 1.25 1.25zm-1.25 5.75c.69036 0 1.25-.5596 1.25-1.25s-.55964-1.25-1.25-1.25-1.25.5596-1.25 1.25.55964 1.25 1.25 1.25z"
        fill="#212121"
        {...props}
      />
    </svg>
  );
};
